import React from "react";

const MenuIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.66663 6.66668C1.66663 6.20644 2.03972 5.83334 2.49996 5.83334H17.5C17.9602 5.83334 18.3333 6.20644 18.3333 6.66668C18.3333 7.12691 17.9602 7.50001 17.5 7.50001H2.49996C2.03972 7.50001 1.66663 7.12691 1.66663 6.66668ZM1.66663 10C1.66663 9.53977 2.03972 9.16668 2.49996 9.16668H17.5C17.9602 9.16668 18.3333 9.53977 18.3333 10C18.3333 10.4602 17.9602 10.8333 17.5 10.8333H2.49996C2.03972 10.8333 1.66663 10.4602 1.66663 10ZM2.49996 12.5C2.03972 12.5 1.66663 12.8731 1.66663 13.3333C1.66663 13.7936 2.03972 14.1667 2.49996 14.1667H17.5C17.9602 14.1667 18.3333 13.7936 18.3333 13.3333C18.3333 12.8731 17.9602 12.5 17.5 12.5H2.49996Z"
        fill="#646F87"
      />
    </svg>
  );
};

export default MenuIcon;
